// extracted by mini-css-extract-plugin
export var about = "about-module--about--9ckSn";
export var why = "about-module--why--3DfbF";
export var values = "about-module--values--3sX8F";
export var content = "about-module--content--u_vqB";